import React from 'react';
import UploadGuideline from '../../../components/Dashboard/UploadGuideline';

const UploadGuidelinePage = () =>{
    return(
        <div className='upload_image_wrapper'>
               <UploadGuideline/>
        </div>
    )
}

export default UploadGuidelinePage;